export enum ReclamationFormTypes {
  COMMERCIAL = 'commercial',
  RETAILER = 'retailer',
  BUILDER_MULTIFAMILY = 'builder_multifamily'
}
